import Vue from 'vue'

/**
 * 操作类型
 * @type {{system: string, business: string}}
 */
export const ACTION_TYPE = {
  system: '0', //内部系统
  business: '1' //业务系统
}

/**
 * 内容类型
 * @type {{IMG: string, TEXT: string}}
 */
export const CONTENT_TYPE = {
  IMG: '1', //图片
  TEXT: '2' //文字
}

// -----------------------------业务系统key配置-------------------------------------
/**
 * 默认集合地址
 * @type {string}
 */
export const CONTENT_KEY_APPLY_ADDRESS = 'APPLY-ADDRESS'

/**
 * 专家咨询电话
 * @type {string}
 */
export const CONTENT_KEY_EXPERT_CONSULT_TELEPHONE = 'EXPERT-CONSULT-TELEPHONE'

/**
 * 专家系统网址
 * @type {string}
 */
export const CONTENT_KEY_EXPERT_SYSTEM_URL = 'EXPERT-SYSTEM-URL'
/**
 * 专家未接听电话重拨次数
 * @type {string}
 */
export const CONTENT_KEY_EXPERT_CALL_BACK_NUM = 'EXPERT-CALL-BACK-NUM'

/**
 * 重拨间隔时长
 */
export const CONTENT_KEY_EXPERT_CALL_BACK_INTERVAL = 'EXPERT-CALL-BACK-INTERVAL'

/**
 * 专家品目最多选择个数
 * @type {string}
 */
export const CONTENT_KEY_EXPERT_ITEM_MAX_NUM = 'EXPERT-ITEM-MAX-NUM'

/**
 * 专家费支付方式
 * @type {string}
 */
export const EXPERT_PAYMENTMETHOD = 'EXPERT-PAYMENTMETHOD'

/**
 * 默认区域
 * @type {string}
 */
export const EXPERT_AREA_ADDRESS = 'EXPERT-AREA-ADDRESS'

/**
 * 微信公众号二维码
 */
export const EXPERT_QR_CODE = 'EXPERT-QR-CODE'

// --------------------------------------------------------------模块用户权限---------------------------------

/**
 * 是否是业务参数配置管理员
 * @returns {boolean}
 */
export const IsScmAdmin = () => {
  let user = Vue.ls.get('user')
  return !!user.permissions['scm.admin']
}



